import { Model } from '@vuex-orm/core'

export default class Tome extends Model {
    static entity = 'tomes'

    static primaryKey = 'area_id'

    static fields() {
        return {
            area_id: this.attr(null),
            completed: this.attr(0),
            total: this.attr(0)
        }
    }
}